/* unplugin-vue-components disabled */import script from "./DelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DelDialog.vue?vue&type=script&setup=true&lang=js"

import "./DelDialog.vue?vue&type=style&index=0&id=137595a6&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户内蒙古医科-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137595a6"]])

export default __exports__